module.exports = __webpack_public_path__ + "img/330.11b9dd91.png";